import { Box, IconButton, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import RenderTriviaForm from './renderTriviaForm';
import { useAuth, useConfig, useProgram, useTrivias } from '~/hooks';
import CloseIcon from '@mui/icons-material/Close';
import { withAuth } from '~/components/AuthGuard';

const TriviaModal = () => {
  const { participant, isLoggedIn } = useAuth();
  const { program } = useProgram();
  const [openTriviaModal, setOpenTriviaModal] = useState(false);
  const { getConfig, data: participantConfig, loading: loadingParticipantConfig } = useConfig();
  const {
    getMatchPredictedTrivia,
    predictedTrivia,
    getAnsweredForm,
    isAnswered,
    loadingIsAnswered,
  } = useTrivias();
  const forms = Array.isArray(participantConfig?.forms)
    ? participantConfig.forms.filter(
        (form) =>
          form &&
          typeof form.id === 'string' &&
          form.id.length > 0 &&
          (form.type === 'FORM' || form.type === 'MATCH_TRIVIA'),
      )
    : [];
  const lastForm = forms.at(-1);

  useEffect(() => {
    if (isLoggedIn && participant) {
      getConfig();
    }
  }, [isLoggedIn, participant]);

  // Cargar respuestas previas
  useEffect(() => {
    if (lastForm?.type === 'MATCH_TRIVIA') {
      getMatchPredictedTrivia(lastForm.id);
    } else if (lastForm?.type === 'FORM') {
      getAnsweredForm(lastForm.id);
    }
  }, [lastForm?.id, lastForm?.type]);

  // Abrir el modal solo cuando ya se tiene info actualizada
  useEffect(() => {
    if (!lastForm || !isLoggedIn || !participant) return;

    const shouldOpen =
      (lastForm.type === 'MATCH_TRIVIA' && !predictedTrivia) ||
      (lastForm.type === 'FORM' && !isAnswered);

    setOpenTriviaModal(shouldOpen);
  }, [isLoggedIn, participant, lastForm?.id, lastForm?.type, predictedTrivia, isAnswered]);

  if (
    loadingParticipantConfig ||
    loadingIsAnswered ||
    !lastForm ||
    program?.id === 28 ||
    program?.id === 39
  ) {
    return null;
  }

  return (
    <Modal open={openTriviaModal} onClose={() => setOpenTriviaModal(false)}>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1300,
          padding: '1rem',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 400,
            borderRadius: 4,
            boxShadow: 10,
          }}
        >
          {/* Botón de cerrar */}
          <IconButton
            onClick={() => setOpenTriviaModal(false)}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'white',
            }}
          >
            <CloseIcon fontSize="large" />
          </IconButton>

          <RenderTriviaForm formId={lastForm.id} type={lastForm.type} />
        </Box>
      </div>
    </Modal>
  );
};

export default withAuth(TriviaModal);
